import React from 'react';
import ReactDOM from 'react-dom';
import SMConst from 'lib/SMConst';
import SMUserBaloonView from 'components/users/SMUserBaloonView';
import SMOwnerBaloonView from 'components/owners/SMOwnerBaloonView';
import SMFormatHelper from './SMFormatHelper';
import sprintf from 'sprintf';
import SMPlanHelper from 'components/helpers/SMPlanHelper';
import SMRoomBaloonView from 'components/rooms/SMRoomBaloonView';
import SMSearchRentTypeView from 'components/search/SMSearchRentTypeView';


class SMRenderHelper {

  static renderFileAttachment(message, name){
    let content = null;
    if (message.file) {
      const separates = message.file.split("?");
      const pathes = separates[0].split("/");
      const fileName = decodeURIComponent(pathes[pathes.length - 1]);

      content = (
        <h3 className="dashboard-message__status">
          <i className="fa fa-paperclip"></i> {name} さんが「<a href={message.file} target="_blank">{fileName}</a>」を添付しました
        </h3>
      );
    }
    return content;
  }

  static renderReviewStars(score){
    let rows = [];
    const number = Math.floor(score) ;
    const max = 5;
    let i = 0;
    for (; i < number; i++) {
      rows.push(
        <i key={i} className="fa fa-star mr2 is-checked"></i>
      );
    }
    if (score == max) return rows;

    if (score >= number + 0.5) {
      rows.push(
        <span key={i} className="star-harf fa fa-star">
          <i className="fa fa-star mr2 is-default"></i>
        </span>
      );
    }
    else if (score < number + 0.5) {
      rows.push(
        <i key={i} className="fa fa-star mr2 is-default"></i>
      );
    }
    i++;
    for (; i < max; i++) {
      rows.push(
        <i key={i} className="fa fa-star mr2 is-default"></i>
      );
    }
    return rows;
  }

  static addObserverForBaloon(el){
    let baloon;
    const $baloonContainer = $("#js-baloon-container");
    $(document).
      on("mouseover", ".js-baloon", function(e){
        const $el = $(this),
            baloonType = $el.data("baloon-type"),
            baloonData = $el.data("baloon-data"),
            buttonTitle = $el.data("baloon-button-title"),
            buttonLink = $el.data("baloon-button-link"),
            frame = {
              size: {
                width: $el.width(),
                height: $el.height()
              },
              offset: $el.offset()
            };

        if (baloonType == "User") {
          baloon = ReactDOM.render(
            <SMUserBaloonView originFrame={frame} user={baloonData} buttonTitle={buttonTitle} buttonLink={buttonLink} />,
            $baloonContainer.get(0)
          );
        }
        else if (baloonType == "Owner") {
          baloon = ReactDOM.render(
            <SMOwnerBaloonView originFrame={frame} owner={baloonData} buttonTitle={buttonTitle} buttonLink={buttonLink} />,
            $baloonContainer.get(0)
          );
        }
        else if (baloonType == "Room") {
          baloon = ReactDOM.render(
            <SMRoomBaloonView originFrame={frame} room={baloonData} buttonTitle={buttonTitle} buttonLink={buttonLink} />,
            $baloonContainer.get(0)
          );
        }
      }).
      on("mouseout", ".js-baloon", function(e){
        setTimeout(function(){
          if (baloon && !baloon.isMouseOver) {
            ReactDOM.unmountComponentAtNode($baloonContainer.get(0));
          }
        }, 300);
      }).
      on("SMHideBaloon", function(e) {
        ReactDOM.unmountComponentAtNode($baloonContainer.get(0));
      });
  }

  static renderEventTypeOptions(eventTypes, defaultLable=I18n.t('service.label_000047')) {
    eventTypes = eventTypes || [];
    let rows = [
      <option key="none" value="">{defaultLable}</option>
    ];
    eventTypes.forEach((eventType)=>{
      rows.push(
        <option key={eventType.id} value={eventType.name}>{eventType.name_text}</option>
      );
    });
    return rows;
  }

  // static renderCapacitySelect(capacities, defaultLable=I18n.t('service.label_000047')) {
  //   capacities = capacities || [];
  //   let rows = [
  //     <option key="none" value="">{defaultLable}</option>
  //   ];
  //   capacities.forEach((capacity)=>{
  //     rows.push(
  //       <option key={capacity.id} value={capacity.name}>{capacity.name_text}</option>
  //     );
  //   });
  //   return rows;
  // }

  static renderSpaceTypeOptions(spaceTypes) {
    spaceTypes = spaceTypes || [];
    let rows = [
      <option key="none" value="">指定なし</option>
    ];
    spaceTypes.forEach((spaceType)=>{
      rows.push(
        <option key={spaceType.id} value={spaceType.name}>{spaceType.name_text}</option>
      );
    });
    return rows;
  }

  static renderTimeOptions() {
    let rows = [
      <option key="none" value="">指定なし</option>
    ];
    for (let i = 0; i < 24; i++) {
      const v = sprintf("%02d:00", i);
      rows.push(
        <option key={i} value={v}>{v}</option>
      );
    }
    return rows;
  }

  static renderAmenityCheckBoxes(amenityList, amenityType, selectedString, onChange, className) {
    amenityList = amenityList || [];
    selectedString = selectedString || "";
    let rows = [];
    const selectedNames = selectedString.split(",");

    amenityList.forEach((amenity)=>{
      if (amenity.amenity_type == amenityType) {
        const id = "form-amenity__checkbox" + amenity.id;
        const checked = selectedNames.indexOf(amenity.name) != -1;
        rows.push(
          <div key={id} className={className}>
            <div className="search-change__amenity-checkbox">
              <input type="checkbox" checked={checked} value={amenity.name} id={id} onChange={onChange} />
              <label htmlFor={id} className="form-checkbox__s">{amenity.name_text}</label>
            </div>
          </div>
        );
      }
    });
    return rows;
  }

  static renderRentTypeCheckBoxes(rentTypeList, selectedString, onChange, className) {
    let addIn = '';
    if(rentTypeList != '') {
      addIn = 'pc';
    } else {
      addIn = 'mb';
    }

    rentTypeList = ['hourly', 'daily', 'stay'] || [];
    selectedString = selectedString || "";
    let rows = [];
    const selectedNames = selectedString.split(",");

    let items = [
      {label: I18n.t("service.label_000015"), value: "hourly"},
      {label: I18n.t("service.label_000016"), value: "daily"},
      {label: I18n.t("service.label_000017"), value: "stay"},
    ];

    rentTypeList.forEach((rentType)=>{
      const index = selectedNames.indexOf(rentType);
      const id = "form-rentType__checkbox" + addIn + rentType.toString();
      const checked = index != -1;
      let item = null;
      let value = null;
      items.forEach((i)=>{
        if(i['value'] == rentType) {
          item = i['label'];
          value = i['value'];
        }
      });

      rows.push([
        <li key={id}>
          <input
            type="checkbox"
            onChange={onChange}
            checked={checked}
            value={value}
            id={id} />
          <label
            htmlFor={id}
            className="form-checkbox__s">{item}</label>
        </li>]);
    });

    return(
      <ul className={className}>
        {rows}
        <input type="hidden" name="price_type" value={selectedNames} />
      </ul>);
  }

  static renderMinRequiredDateOrTime(plan, className) {
    className = className || "";
    if (SMPlanHelper.shoudRenderMinRequiredDate(plan)) {
      const str = sprintf("最低%s日間から", plan.min_required_hour);
      return <span className={className}>{str}</span>;
    } else if (SMPlanHelper.shouldRenderMinRequiredTime(plan)){
      const str = sprintf("最低%s時間から", plan.min_required_hour);
      return <span className={className}>{str}</span>;
    }
    return null;
  }

  static renderHasRequiredFood(plan, className) {
    className = className || "";
    if (SMPlanHelper.shouldRenderRequiredFood(plan)) {
      return <span className={className}>飲食必須</span>;
    }
    return null;
  }

  static renderDirectReservationIcon(plan) {
    if (plan.direct_reservation_accepted) {
      return (
        <span className="reserve-plan__direct">
          <i className="fa fa-flash fa-lg space-main__plan-title-direct-icon"></i>
          今すぐ予約可能
        </span>
      );
    }
    return null;
  }

  static renderLastMinuteDiscountIcon(plan) {
    if (plan.is_last_minute_discount) {
      return (
        <span className="reserve-plan__direct">
          <i className="fa fa-lg icon-spm-discount space-main__plan-title-discount-icon"></i>
          直前割あり
        </span>
      );
    }
    return null;
  }

  static renderBillingTable(reservation, options) {
    if (!reservation) return;
    const planName = SMFormatHelper.planName(reservation.plan || reservation.room);
    const planNameText = sprintf("%s（%s）", planName, reservation.billing.room_amount_text);
    const optionItemsText = function(items) {
      let rows = [];
      if (!items) items = [];
      items.forEach((item)=>{
        const content = sprintf("%s (%s)",
          item.name,
          SMFormatHelper.reservationOptionQuantity(item)
        );
        rows.push(content);
      });
      return rows.join(", ");
    };

    let rows = [];
    const rent_type = reservation.plan ? reservation.plan.rent_type : reservation.room.rent_type;
    const reservedDate = rent_type == SMConst.RentType.Stay ? (reservation.checkin_date + "〜" + reservation.checkout_date) : reservation.reserved_date_text;

    rows.push(<dt key="2">プラン料金</dt>);
    rows.push(<dd key="3">{planNameText}</dd>);

    if (reservation.reserved_option_items && reservation.reserved_option_items.length > 0) {
      rows.push(<dt key="4">設備・サービス</dt>);
      rows.push(<dd key="5">{optionItemsText(reservation.reserved_option_items)}</dd>);
    }
    if (reservation.reserved_option_foods && reservation.reserved_option_foods.length > 0) {
      rows.push(<dt key="6">飲食</dt>);
      rows.push(<dd key="7">{optionItemsText(reservation.reserved_option_foods)}</dd>);
    }
    if (reservation.billing.last_minute_discount_amount_except_tax > 0) {
      rows.push(<dt key="8">直前割</dt>);
      rows.push(<dd key="9"><span className="is-minus">- {reservation.billing.last_minute_discount_amount_except_tax_text}</span></dd>);
    }

    rows.push(<dt key="10" className="request-breakdown__detail-help">サービス料<span className="request-breakdown__help"><i className="fa fa-question-circle"></i><span className="mod-tooltip request-breakdown__help-tooltip"><span className="baloon baloon-top user-detail-baloon mod-tooltip__detail request-breakdown__help-baloon"><span className="baloon-inner">サービスの維持管理費として、プラン料金、設備・サービスを合わせた料金の5％がかかります。</span></span></span></span>
    </dt>);
    rows.push(<dd key="11">{reservation.billing.guest_fee_amount_text}</dd>);
    if (reservation.billing.is_applied_point) {
      rows.push(<dt key="12">ポイント割引</dt>);
      rows.push(<dd key="13"><span className="is-minus">- {reservation.billing.point_discount_amount_text}</span></dd>);
    }
    if (reservation.billing.payment_method === SMConst.PaymentMethod.Postpay) {
      rows.push(<dt key="14">後払い手数料<span className="request-breakdown__help"><i className="fa fa-question-circle"></i><span className="mod-tooltip request-breakdown__help-tooltip"><span className="baloon baloon-top user-detail-baloon mod-tooltip__detail request-breakdown__help-baloon"><span className="baloon-inner">銀行振込の後払い手数料として、プラン料金、設備・サービスを合わせた料金の3％がかかります。</span></span></span></span></dt>);
      rows.push(<dd key="15">{reservation.billing.guest_postpay_fee_amount_text}</dd>);
    }
    rows.push(<dt key="16">消費税</dt>);
    rows.push(<dd key="17">{reservation.billing.guest_sales_tax_text}</dd>);

    const pointRow = reservation.point_amount ? <p className="request-breakdown__point">このスペース利用で<span className="request-breakdown__point-have">{reservation.point_amount_text}</span>ポイント獲得予定です。</p> : null;

    if (reservation.billing.is_applied_coupon) {
      return(
        <div>
          <dl className={options.className}>
            <dt className="request-breakdown__all">利用期間</dt>
            <dd className="request-breakdown__all">{reservedDate}</dd>
          </dl>
          <dl className={options.className}>
            {rows}
            <dt className="request-breakdown__all">小計</dt>
            <dd className="request-breakdown__all">{reservation.billing.guest_total_amount_with_tax_text}</dd>
          </dl>
          <dl className={options.className}>
            <dt>クーポン割引</dt>
            <dd><span className="is-minus">- {reservation.billing.discount_amount_text}</span></dd>
            <dt className="request-breakdown__all">合計</dt>
            <dd className="request-breakdown__all">{reservation.billing.total_pay_amount_for_user_with_tax_text}</dd>
          </dl>
          {pointRow}
        </div>
      );
    } else {
      return(
        <div>
          <dl className={options.className}>
            <dt className="request-breakdown__all">利用期間</dt>
            <dd className="request-breakdown__all">{reservedDate}</dd>
          </dl>
          <dl className={`${options.className} request-breakdown__bottom-border`}>
            {rows}
            <dt className="request-breakdown__all">合計</dt>
            <dd className="request-breakdown__all">{reservation.billing.total_pay_amount_for_user_with_tax_text}</dd>
          </dl>
          {pointRow}
        </div>
      );
    }
  }

  static renderReservationIcon(reservation) {
    if (!reservation.reserved_date_text) { return null; }

    let className = null;
    let title = null;

    if (reservation.rent_type == SMConst.RentType.Stay) {
      className = 'icon-spm-stay';
      title = '宿泊';
    } else if (reservation.is_hourly) {
      className = 'icon-spm-time';
      title = '時間貸し';
    } else {
      className = 'icon-spm-day';
      title = '1日貸し';
    }

    return <i className={className + ' mr5'} title={title}></i>;
  }

  static renderRentType(str) {
    return(
      <SMSearchRentTypeView
        priceType={str}
        options={{className: "search-change__type"}} />
    );
  }

  static hideIfEmpty(array){
    return array && array.length > 0 ? {} : {display: "none"};
  }

  static isVimeoUrl(url) {
    return (url && url.match(/vimeo\.com/));
  }

  static videoUrl(url) {
    if (this.isVimeoUrl(url)) {
      return "//player.vimeo.com/video/" + this.videoId(url);
    } else {
      return "//www.youtube.com/embed/" + this.videoId(url);
    }
  }

  static videoId(url) {
    let arr = url.split((this.isVimeoUrl(url)) ? '/' : '=');
    return arr[arr.length - 1];
  }
}
export default SMRenderHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMRenderHelper.js